import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed, watch, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { ModalHelper } from '@/helpers/modal-helper';
import WatchNowButtonNew from '@/components/buttons/WatchNowButtonNew.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { ThumborOptions } from '@/filters/thumbor';
import LabeledButton from './LabeledButton.vue';
import { isTitleInList } from '@/helpers/title-helper';
import { TitleListType } from '@/@types/graphql-types';

import { formatRuntime } from '@/helpers/title-helper';
import { useI18n } from '@/helpers/composables/useI18n';
import { faBookmark, faCheck, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';

import ReelsExp from '../index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReelControlOverlay',
  props: {
    title: { default: {} }
  },
  emits: ["action"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'action', action: string, title: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: any };

const router = useRouter();





const { t } = useI18n();
const runtime = computed(() => {
	const runtimeValue = props.title.content.runtime!;
	const { translationKey, minutes, hours } = formatRuntime(runtimeValue);

	return t(translationKey, { minutes, hours }) as string;
});

const posterUrl = ref<string>(props.title.content?.posterUrl ?? '');
const imageUrl = ref<string>(
	Vue.filter('Thumbor')({
		url: posterUrl.value,
		imageType: 'poster',
	} as ThumborOptions)
);

const likes = computed(() => props.title?.content?.interactions?.likelistAdditions || 0);
const dislikes = computed(() => props.title?.content?.interactions?.dislikelistAdditions || 0);

const isInSeenList = computed(() => isTitleInList(TitleListType.CaughtUp, props.title));
const isInWatchlist = computed(() => isTitleInList(TitleListType.WatchNext, props.title));
const isInLikeList = computed(() => isTitleInList(TitleListType.Likelist, props.title));
const isInDislikeList = computed(() => isTitleInList(TitleListType.Dislikelist, props.title));

const titleUrl = computed(() => props.title.content?.fullPath ?? '');

function goToTitleDetails() {
	ReelsExp.trackEvent({
		action: 'click',
		label: 'title_clicked',
		property: 'shorts_popular',
	});
	router.push({ path: titleUrl.value });
	ModalHelper.close();
}

watch(
	() => props.title,
	newVal => {
		posterUrl.value = props.title.content?.posterUrl ?? '';
		imageUrl.value = Vue.filter('Thumbor')({
			url: posterUrl.value,
			imageType: 'poster',
		} as ThumborOptions);
	}
);

function onClickout() {
	ReelsExp.trackEvent({
		action: 'click',
		label: 'clickout',
		property: 'shorts_popular',
	});
}

function handleClick(label: string, actionType: string) {
	ReelsExp.trackEvent({
		action: 'click',
		label: `${label}_add`,
		property: 'shorts_popular',
	});
	emits('action', actionType, props.title);
}

return { __sfc: true,router, props, emits, t, runtime, posterUrl, imageUrl, likes, dislikes, isInSeenList, isInWatchlist, isInLikeList, isInDislikeList, titleUrl, goToTitleDetails, onClickout, handleClick, WatchNowButtonNew, PictureComp, LabeledButton, faBookmark, faCheck, faThumbsUp, faThumbsDown }
}

})